<template>
  <a-row>
    <a-col
      :span="10"
      style="font-size: 22px;font-family: FZLanTingHei-R-GBK;font-weight: 400;color: #FFFFFF;"
    >
      <img
        src="../assets/logo.svg"
        style="width:32px;height:32px;margin-right:10px;"
      />
      测绘所房屋管理系统
    </a-col>
    <a-col
      :span="12"
      style="text-align:right;"
    >
      <a-menu
        mode="horizontal"
        theme="dark"
        :style="{ lineHeight: '64px' }"
      >
        <a-menu-item
          key="board"
          class="dd-manage"
          @click="$router.push('/')"
          v-show="parent=='home'"
        >
          <div class="dd-submenu-title-wrapper">
            <img src="../assets/home.png" /><br>
            首页
          </div>
        </a-menu-item>
        <a-menu-item
          key="home"
          class="dd-manage"
          @click="$router.push('/home')"
          v-show="parent=='manage'"
        >
          <div class="dd-submenu-title-wrapper">
            <img src="../assets/search_unselected.png" /><br>
            查询分析
          </div>
        </a-menu-item>
        <a-sub-menu v-show="false">
          <div
            slot="title"
            class="dd-submenu-title-wrapper"
          >
            <img src="../assets/search_unselected.png" /><br>
            查询
          </div>
          <a-menu-item @click="menuClick('search_rect')">框选查询</a-menu-item>
          <a-menu-item @click="menuClick('search_polygon')">多边形查询</a-menu-item>
          <a-menu-item @click="menuClick('search_circle')">圆形查询</a-menu-item>
          <a-menu-item @click="menuClick('search_point')">点识别</a-menu-item>
          <a-menu-item @click="menuClick('search_attr')">按属性查询</a-menu-item>
        </a-sub-menu>
        <a-sub-menu v-show="false">
          <div
            slot="title"
            class="dd-submenu-title-wrapper"
          >
            <img src="../assets/analysis_unselected.png" /><br>
            分析
          </div>
          <a-menu-item @click="menuClick('buffer_ana')">缓冲分析</a-menu-item>
          <a-menu-item @click="menuClick('intersect_ana')">叠加分析</a-menu-item>
          <!-- <a-menu-item @click="menuClick('buffer_ana')">合并分析</a-menu-item> -->
          <a-menu-item @click="menuClick('union_ana')">联合分析</a-menu-item>
          <a-menu-item @click="menuClick('compare_ana')">多时相分析</a-menu-item>
        </a-sub-menu>
        <a-sub-menu v-show="false">
          <div
            slot="title"
            class="dd-submenu-title-wrapper"
          >
            <img src="../assets/tools_unselected.png" /><br>
            工具
          </div>
          <a-menu-item @click="toolClick('length')">测距</a-menu-item>
          <a-menu-item @click="toolClick('area')">测面积</a-menu-item>
          <a-menu-item @click="toolClick('point')">标绘点</a-menu-item>
          <a-menu-item @click="toolClick('line')">标绘线</a-menu-item>
          <a-menu-item @click="toolClick('polygon')">标绘面</a-menu-item>
          <a-menu-item @click="toolClick('location')">坐标定位</a-menu-item>
          <!-- <a-menu-item>收藏</a-menu-item> -->
          <!-- <a-menu-item>打印</a-menu-item> -->
        </a-sub-menu>
        <a-menu-item
          key="manage"
          class="dd-manage"
          @click="$router.push('/manage')"
          v-show="parent=='home' && ($store.state.user.role_no=='001' || $store.state.user.role_no=='002' ) "
        >
          <div class="dd-submenu-title-wrapper">
            <img src="../assets/manage_unselected.png" /><br>
            系统管理
          </div>
        </a-menu-item>
      </a-menu>
    </a-col>
    <a-col
      :span="2"
      style="color:rgba(255, 255, 255, 0.65);"
    >
      <a-divider type="vertical" />

      <a-dropdown>
        <a
          class="ant-dropdown-link"
          @click="e => e.preventDefault()"
          :title="$store.state.user.name"
        >
          <a-button
            shape="circle"
            icon="user"
            class="dd-user-icon"
          />
          <span class="dd-user-name">
            {{this.$store.state.user.name}}
          </span>
          <a-icon type="caret-down" />
        </a>
        <a-menu slot="overlay">
          <a-menu-item
            key="0"
            @click="logout"
          >退出
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </a-col>
  </a-row>

</template>

<script>
import dbTool from '../utils/localDb';

export default {
  name: "Header",
  props: ["parent"],
  data() {
    return {
    }
  },
  methods: {
    logout() {
      dbTool.clear();
      this.$router.push("/login");
    },
    menuClick(menu) {
      this.$emit("menuClick", menu);
    },
    toolClick(menu) {
      this.$emit("toolClick", menu);
    }
  }
}
</script>
<style lang="scss" scoped>
.ant-col {
  height: 100%;
}
.ant-layout-header {
  .ant-menu {
    background: none;
    text-align: right;
    margin: auto;
    & > .ant-menu-item {
      padding: 0px;
    }
    .dd-submenu-title-wrapper {
      line-height: 2;
      text-align: center;
      width: 80px;
      height: 64px;
      padding-top: 10px;
      font-size: 14px;
      font-family: FZLanTingHei-EL-GBK;
      font-weight: 400;
      color: #dbdbdb;
    }
  }
  .ant-divider-vertical {
    margin-left: 5px;
    margin-right: 25px;
    height: 1.2em;
    background-color: #dbdbdb;
  }
}
</style>
<style lang="scss">
.ant-menu-submenu {
  & > .ant-menu-submenu-title {
    padding: 0px !important;
  }
}
.ant-menu-submenu-content {
  background: rgba(13, 25, 68, 1) !important;
  font-size: 14px;
  font-family: FZLanTingHei-EL-GBK;
  font-weight: 400;
  color: #dbdbdb;
  & .ant-menu-item-selected {
    background-color: rgba(147, 147, 148, 0.9) !important;
  }
}
.dd-manage {
  background: none !important;
}
.dd-user-icon {
  background: none !important;
  color: #dbdbdb !important;
  border-color: #dbdbdb;
}
.ant-dropdown-link {
  color: #dbdbdb;
}
.ant-dropdown-link:hover {
  color: #fff;
}
.dd-user-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  max-width: 64px;
  line-height: 1;
  padding-left: 4px;
}
</style>